import { Checkbox, FormControlLabel, type CheckboxProps } from "@mui/material";
import { formControlLabelAlignSx } from "../../lib/ui/formLayout";

type Props = CheckboxProps & {
  label: string;
};

/** Standard MUI checkbox with label. */
export default function AppCheckbox({ label, ...checkboxProps }: Props) {
  return (
    <FormControlLabel
      sx={formControlLabelAlignSx}
      control={<Checkbox size="small" {...checkboxProps} />}
      label={label}
    />
  );
}
